import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding-top: 25px;
`

export const StyledUL = styled.ul`
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
